import React from "react";

const MetricCard = ({
  title,
  value,
  icon: Icon,
  trend,
  trendUp,
  backgroundColor,
  iconBackground,
}) => {
  return (
    <div
      className="metric-card"
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <div className="metric-card-header">
        {Icon ? (
          <span
            className="metric-card-icon-wrapper"
            style={iconBackground ? { backgroundColor: iconBackground } : undefined}
          >
            <Icon className="metric-card-icon" />
          </span>
        ) : null}
        <div className="metric-card-body">
          <p className="metric-card-title">{title}</p>
          <p className="metric-card-value">{value}</p>
          {trend ? (
            <p className={`metric-card-trend ${trendUp ? "trend-up" : "trend-neutral"}`}>
              {trend}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;

